import React, { Component } from 'react';
import Modal from '../modal/modal'
import './classwork-modal.css'
import { goldModal } from '../operation-panel/class-work'
import { baizeGoldModal } from '../operation-panel/baize'


export default (props) => {
  const { goldUrl, close, isOpen, canBeShare } = props

  const handleGoldFrameOnLoad = () => {
    setTimeout(() => {
      const _goldModal = goldModal || baizeGoldModal
      _goldModal.toggle(false);
    }, 2000);
  };

  return (
    <Modal
      isOpen={isOpen}
    >
      {
        canBeShare ?
        (
          <div className='modal-content'>
              <div className='div-btn' onClick={close}>×</div>
              <p className='title'>提交成功啦</p>
              <p className='subtitle'>快让小伙伴体验一下你的编程作品吧</p>
              <canvas className='qr-code' id="xes-classwork-share"></canvas>
              <p className='subtitle'>微信扫一扫</p>
              <p className='subtitle'>分享到朋友圈</p>
          </div>
        ) :
        (
          <iframe onLoad={handleGoldFrameOnLoad} frameBorder="no" className='iframe' src={ goldUrl } />
        )
      }
    </Modal>
  )
}